import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    // Initialize auth state from localStorage if available
    const storedAuth = localStorage.getItem("LoginSession");
    if (storedAuth) {
      try {
        const parsedAuth = JSON.parse(storedAuth);
        // Ensure backward compatibility - if user is a string (old format), convert to object
        if (parsedAuth.user && typeof parsedAuth.user === 'string') {
          parsedAuth.user = { id: parsedAuth.user };
        }
        return parsedAuth;
      } catch (error) {
        console.error('Error parsing stored auth:', error);
        return {};
      }
    }
    return {};
  });

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
